import "default-passive-events";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import util from "./utils/utils";
import i18n from "@/i18n/index";
import api from "./api";
import { tokenExpired } from "./router/tokenExpired";
import VueLoading from "vue-loading-template";
import { message } from "@/utils/message.js";
import "@/utils/useQuill.js";
import GlobalComponents from "./utils/installGlobalCompontents";
import directiveFixedScroll from "@/utils/directiveFixedScroll";
import { ensureCommentActionSprite } from "@/assets/icon/icons.js";
import { preloadNotificationSound } from "@/utils/notificationSound";
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";

/* 改变主题色变量 */
import "@theme-entry";
import "./assets/css/magic-quill-editor.scss";
import "./assets/css/markdown-reset.scss";
import "./assets/css/animatecss-reset.scss";
import "./assets/font/iconfont.css";
import "./assets/css/element-overrides.scss";
import "./assets/css/utilities.scss";
import "./assets/css/h-css.scss";
import "./assets/css/styles-v2.scss";
import "animate.css/animate.min.css";
import "@icon-park/vue/styles/index.css";
import "@flaticon/flaticon-uicons/css/regular/all.css";
Vue.config.productionTip = false;
Vue.prototype.$axios = api;
Vue.prototype.$tokenExpired = tokenExpired;
Vue.prototype.$message = message;
Vue.prototype.common = util;
Vue.prototype.$aiHost = process.env.VUE_APP_AI_API_URL;
Vue.prototype.$PyHost = process.env.VUE_APP_PY_CN_API_URL;
Vue.prototype.$socketHost = process.env.VUE_APP_SOCKET_API_URL;
// process.env.NODE_ENV === "production" ? "wss://gc.pandarocket.cn/ws" : "wss://caomei.emkol.cn/ws";

// 应用入口即预加载提示音，避免首次通知等待 Layout 异步 chunk 和音频资源下载。
preloadNotificationSound();
export const eventBus = new Vue();
export const baseURL = {
  $aiHost: process.env.VUE_APP_AI_API_URL,
  $PyHost: process.env.VUE_APP_PY_CN_API_URL,
  $socketHost: process.env.VUE_APP_SOCKET_API_URL
};

// 侧栏等首屏图标依赖该精灵图；应用初始化时预热，避免等待懒加载路由创建首个图标后才发起请求。
ensureCommentActionSprite().catch(() => {
  // 预热失败不阻断应用启动，后续 LocalSvgIcon 会利用可重试逻辑再次请求。
});
Vue.use(VueLoading /** options **/);
Vue.use(GlobalComponents);
Vue.use(FloatingVue);
Vue.use(directiveFixedScroll);
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");